// @ts-ignore
import userStore from '@/stores/user/index';

// 获取 context nlu typing 实验组
const getContextNluTypingBehaviour = () => {
  const controlGroup = (userStore.newABTestingConfigs as any)?.context_nlu_typing_behaviour;
  if (controlGroup === 'concat_1') {
    return 3000; // 由 2000 改为 3000
  } else if (controlGroup === 'concat_2') {
    return 4000; // 由 3000 改为 4000
  } else {
    return 0;
  }
};

export default getContextNluTypingBehaviour;
